<template>
  <div>
    <div class="head_box flex_space flex_center_align" @click="fold = !fold">
      <div class="flex_start flex_center_align">
        <svg-icon icon-class="edit_2_line"></svg-icon>
        <span class="hd_title">
          <slot name="title"></slot>
        </span>
      </div>
      <div class="arrow_box flex_center_align flex_center">
        <!-- <img
          class="arrow_img"
          src="~@/assets/images/up.png"
          :class="{ rote: fold }"
        /> -->
        <svg-icon
          icon-class="up_line"
          class="arrow_svg"
          :class="{ rote: fold }"
        />
      </div>
    </div>
    <div v-show="!fold" class="file_box m20">
      <vab-row class="row_box gray">
        <vab-col :span="8" class="boxleft ht">工事部</vab-col>
        <vab-col :span="8" class="boxleft ht">LC</vab-col>
        <vab-col :span="8" class="boxleft ht">PS課</vab-col>
      </vab-row>
      <vab-row class="row_box">
        <vab-col
          :span="8"
          class="boxleft flex_colum"
          :class="{ gray: type < 2 }"
        >
          <template v-if="type > 2">
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【工事中の実施可否】</div>
              <div class="gcs_title">予定通り実施</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【コメント】</div>
              <div class="gcs_title">よろしくお願いいたします。</div>
            </div>
          </template>
          <template v-else>
            <vab-select
              label="工事中の実施可否"
              label-width="150px"
              prop="gszkf"
              data-key="gszkfcont"
              label-id="label"
              value-id="value"
              data-type="local"
              validate="required"
              :disabled="type < 2"
              clearable
            />
            <vab-textarea
              label="コメント"
              prop="JCInfoData.constructionRecordMemo"
              :rows="4"
              :disabled="type < 2"
            ></vab-textarea>
          </template>
        </vab-col>
        <vab-col
          :span="8"
          class="boxleft flex_colum"
          :class="{ gray: type < 3 }"
        >
          <template v-if="type > 3">
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【実施判断】</div>
              <div class="gcs_title">予定通り実施</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【実施月】</div>
              <div class="gcs_title">設定月以外でも可能</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【同日実施】</div>
              <div class="gcs_title">ずらさない</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【点検実施範囲】</div>
              <div class="gcs_title">縮小または変更</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【コメント】</div>
              <div class="gcs_title">よろしくお願いいたします。</div>
            </div>
          </template>
          <template v-else>
            <vab-select
              label="実施判断"
              label-width="150px"
              prop="sspd"
              data-key="sspdconst"
              label-id="label"
              value-id="value"
              data-type="local"
              validate="required"
              clearable
              :disabled="type < 3"
            />
            <vab-select
              label="実施月"
              label-width="150px"
              prop="ssy"
              data-key="ssyconst"
              label-id="label"
              value-id="value"
              data-type="local"
              validate="required"
              clearable
              :disabled="type < 3"
            />
            <vab-select
              label="工事中の実施可否"
              label-width="150px"
              prop="gskf"
              data-key="gszkfcont"
              label-id="label"
              value-id="value"
              data-type="local"
              validate="required"
              clearable
              :disabled="type < 3"
            />
            <vab-textarea
              label="コメント"
              prop="JCInfoData.constructionRecordMemo"
              :rows="4"
              :disabled="type < 3"
            ></vab-textarea>
          </template>
        </vab-col>
        <vab-col
          :span="8"
          class="boxleft flex_colum"
          :class="{ gray: type < 4 }"
        >
          <template v-if="type > 4">
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【作業月の変更】</div>
              <div class="gcs_title">なし</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【変更月】</div>
              <div class="gcs_title">2022/09</div>
            </div>
            <div class="gcs_item flex_colum">
              <div class="gcs_title">【コメント】</div>
              <div class="gcs_title">よろしくお願いいたします。</div>
            </div>
          </template>
          <template v-else>
            <vab-radio-group
              prop="asbestoContainFlg"
              label="作業月の変更"
              label-width="150px"
              data-type="local"
              data-key="tzList"
              label-id="name"
              value-id="mode"
              :disabled="type < 4"
            />
            <vab-date-picker
              type="date"
              label="変更月"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              prop="planContractStartDate"
              :disabled="type < 4"
            />
            <vab-textarea
              label="コメント"
              prop="JCInfoData.constructionRecordMemo"
              :rows="4"
              :disabled="type < 4"
            ></vab-textarea>
          </template>
        </vab-col>
      </vab-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VabWork',
    // eslint-disable-next-line vue/require-prop-types
    props: ['type'],
    data() {
      return {
        fold: false,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .boxleft ::v-deep {
    .el-form-item__content {
      width: 100%;
    }
  }
  .arrow_box {
    width: 44px;
    height: 15px;
    cursor: pointer;
    .arrow_img {
      width: 24px;
      height: 24px;
    }
    .arrow_svg {
      font-size: 24px;
      color: #919191;
    }
  }
  .rote {
    transform: rotate(180deg);
  }
  .info_main .head_box {
    padding: 10px 0;
    cursor: pointer;
  }
  .boxleft {
    .gcs_item {
      padding-bottom: 8px;
      border-bottom: 1px solid #d1dae1;
      margin-bottom: 8px;
      .gcs_title {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        padding: 5px 0;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
</style>
